export class UpdateProgressDto {
    public ProgressPercentage: number;

    constructor(progress: number) {
        this.ProgressPercentage = progress;
    }
}
